import { hlvCoverNeeded, requiredSIPForTarget } from "../../engine/calculations";

const config = {
  key: "term-plus-sip-need",
  title: "Term Insurance + SIP (Need-Based)",
  category: "Insurance & Protection",
  description: "Size both the term cover you need to protect your family and the SIP you need for a separate goal.",
  fields: [
    { key: "annualIncome", label: "Annual income", type: "currency", default: 12_00_000, min: 1000, max: 10_00_00_000, profileKey: "annualIncome" },
    { key: "supportYears", label: "Years of income to replace", type: "number", default: 15, min: 1, max: 40 },
    { key: "loans", label: "Outstanding loans", type: "currency", default: 20_00_000, min: 0, max: 10_00_00_000 },
    { key: "existingInvestments", label: "Existing investments", type: "currency", default: 10_00_000, min: 0, max: 10_00_00_000, profileKey: "netWorth" },
    { key: "existingCover", label: "Existing insurance cover", type: "currency", default: 0, min: 0, max: 10_00_00_000 },
    { key: "sipGoalAmount", label: "Separate investment goal amount", type: "currency", default: 50_00_000, min: 1000, max: 10_00_00_000, help: "e.g. a retirement or education corpus, on top of the protection above." },
    { key: "sipYears", label: "Years to reach that goal", type: "number", default: 15, min: 1, max: 40 },
    { key: "sipReturnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
  ],
  compute(values) {
    const annualIncome = Number(values.annualIncome) || 0;
    const supportYears = Number(values.supportYears) || 0;
    const loans = Number(values.loans) || 0;
    const existingInvestments = Number(values.existingInvestments) || 0;
    const existingCover = Number(values.existingCover) || 0;
    const sipGoalAmount = Number(values.sipGoalAmount) || 0;
    const sipYears = Number(values.sipYears) || 0;
    const sipReturnRate = (Number(values.sipReturnRate) || 0) / 100;

    const coverNeeded = hlvCoverNeeded({ annualIncome, supportYears, loans, existingInvestments, existingCover });
    const requiredMonthlySIP = requiredSIPForTarget(sipGoalAmount, sipReturnRate, sipYears * 12);

    return {
      headline: { label: "Additional term cover needed", value: coverNeeded },
      extraHeadlines: [{ label: "Required monthly SIP for your goal", value: requiredMonthlySIP }],
      breakdown: [
        { label: "Income to replace", value: annualIncome * supportYears },
        { label: "Loans", value: loans },
        { label: "Existing investments + cover", value: existingInvestments + existingCover },
        { label: "Separate goal amount", value: sipGoalAmount },
      ],
    };
  },
};

export default config;
